import { Injectable, EventEmitter } from "@angular/core";
import { SaveSearches } from "../models/save-searches";
import { Shared } from "../models/shared";
import { HttpClientWrapper } from "./httpclientwrapper";
import { Observable } from 'rxjs';
import { CheckPlatformService } from '../services/check-platform.service';

@Injectable({
  providedIn: 'root'
})
export class SaveSearchServices {
 
  baseUrl: string = Shared.baseUrl;
  isBrowser: boolean;
  saveSearches: SaveSearches[] = [];
  constructor(private http: HttpClientWrapper,
    private checkPlatformService: CheckPlatformService) {
    if (this.checkPlatformService.isBrowser()) {

      this.isBrowser = true;
    }
  }

  GetSaveSearches(

    userId: number = null
    , keyWords: string = null
    , allofTheseWords: string = null
    , exactPharse: string = null
    , anyofTheseWords: string = null
    , noneofTheseWords: string = null
    , locationId: number = null
    , locationText: string  = null
    , salaryDurationId: number = null
    , salaryFrom: number = null
    , salaryTo: number = null
    , jobTypeIds: string = null
    , jobCategoryIds: string = null
    , positionTypeIds: string = null
    , candidateTypeIds:string = null
    , sectorId: number = null
    , searchWithInLast: number = null
    , radius: number = null
    , isSearchInTitle: boolean = null
    , isBroadMatch: boolean = null
    , isFilterApplyed: boolean = null
    , isJobSearch: boolean = null
    , isCvSearch: boolean = null
    , isBooleanSearch: boolean = null
    , isSearchByLocation: boolean = null
    , isSearchByIndustry: boolean = null
    , emailFrequencyId: number = null
    , savedSearchTypeId: number = null
    , createdOn: Date = null
    , isActive: boolean = null

  ): Observable<SaveSearches[]> {

    let requesPramas = "?"

    if (userId !== undefined && userId != null && userId > 0) {

      requesPramas += "userId=" + userId ;
    }
    
    if (keyWords !== undefined && keyWords != null && keyWords != "") {
 
      requesPramas += "keyWords=" + keyWords;
      // isDefault = false;
    }
    if (allofTheseWords !== undefined && allofTheseWords != null && allofTheseWords != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "allofTheseWords=" + allofTheseWords; 
    }
    if (exactPharse !== undefined && exactPharse != null && exactPharse != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "exactPharse=" + exactPharse; 
    }
    if (anyofTheseWords !== undefined && anyofTheseWords != null && anyofTheseWords != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "anyofTheseWords=" + anyofTheseWords; 
    }
    if (noneofTheseWords !== undefined && noneofTheseWords != null && noneofTheseWords != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "noneofTheseWords=" + noneofTheseWords; 
    } 
    if (locationId !== undefined && locationId != null && locationId > 0) {

      requesPramas += "locationId=" + locationId ;
    }
    if (locationText !== undefined && locationText != null && locationText != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "locationText=" + locationText; 
    } 
    if (salaryDurationId !== undefined && salaryDurationId != null && salaryDurationId > 0) {

      requesPramas += "salaryDurationId=" + salaryDurationId ;
    }
    if (salaryFrom !== undefined && salaryFrom != null && salaryFrom != 0 && salaryFrom.toString() != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "salaryFrom=" + salaryFrom;
    }

    if (salaryTo !== undefined && salaryTo != null && salaryTo != 0 && salaryTo.toString() != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "salaryTo=" + salaryTo;
    }
    if (jobTypeIds !== undefined && jobTypeIds != null && jobTypeIds != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "jobTypeIds=" + jobTypeIds; 
    } 
    if (jobCategoryIds !== undefined && jobCategoryIds != null && jobCategoryIds != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "jobCategoryIds=" + jobCategoryIds; 
    } 
    if (positionTypeIds !== undefined && positionTypeIds != null && positionTypeIds != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "positionTypeIds=" + positionTypeIds; 
    } 
    if (candidateTypeIds !== undefined && candidateTypeIds != null && candidateTypeIds != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "candidateTypeIds=" + candidateTypeIds; 
    } 
    if (sectorId !== undefined && sectorId != null && sectorId > 0) {

      requesPramas += "sectorId=" + sectorId ;
    }
    if (searchWithInLast !== undefined && searchWithInLast != null && searchWithInLast > 0) {

      requesPramas += "searchWithInLast=" + searchWithInLast ;
    }
    if (radius !== undefined && radius != null && radius != 0 && radius.toString() != "") {

      requesPramas += (requesPramas == "?" ? "" : "&") + "radius=" + radius;
    } 
    if (isSearchInTitle !== undefined && isSearchInTitle != null && isSearchInTitle != false) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "isSearchInTitle=" + isSearchInTitle;
    }
    if (isBroadMatch !== undefined && isBroadMatch != null && isBroadMatch != false) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "isBroadMatch=" + isBroadMatch;
    }
    if (isFilterApplyed !== undefined && isFilterApplyed != null && isFilterApplyed != false) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "isFilterApplyed=" + isFilterApplyed;
    }
    if (isJobSearch !== undefined && isJobSearch != null && isJobSearch != false) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "isJobSearch=" + isJobSearch;
    }

    if (isCvSearch !== undefined && isCvSearch != null && isCvSearch != false) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "isCvSearch=" + isCvSearch;
    }
    if (isBooleanSearch !== undefined && isBooleanSearch != null && isBooleanSearch != false) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "isBooleanSearch=" + isBooleanSearch;
    }

    if (isSearchByLocation !== undefined && isSearchByLocation != null && isSearchByLocation != false) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "isSearchByLocation=" + isSearchByLocation;
    }

    if (isSearchByIndustry !== undefined && isSearchByIndustry != null && isSearchByIndustry != false) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "isSearchByIndustry=" + isSearchByIndustry;
    }
    if (emailFrequencyId !== undefined && emailFrequencyId != null && emailFrequencyId > 0 ) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "emailFrequencyId=" + emailFrequencyId;
    } 
    if (savedSearchTypeId !== undefined && savedSearchTypeId != null && savedSearchTypeId > 0 ) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "savedSearchTypeId=" + savedSearchTypeId;
    } 
    if (createdOn !== undefined && createdOn != null) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "createdOn=" + createdOn;
    }
    if (isActive !== undefined && isActive != null && isActive != false) {

      requesPramas += (requesPramas == "?" ? "" : "&") + "isActive=" + isActive;
    }
 
    if (requesPramas == "?") {

      requesPramas = "";
    }

    return this.http.GetAsync<SaveSearches[]>(this.http.BaseUrl + "api/SaveSearches/search" + requesPramas);
  }

  SaveSearches(saveSearches: SaveSearches): Observable<any> {

    if (saveSearches !== undefined && saveSearches != null) {

      saveSearches.SavedSearchTypeId = 2;// 2 is saved by user 
    }

    return this.http.PostAsync<any>(this.http.BaseUrl + "api/SaveSearches", saveSearches);
  }

  DeleteSaveSearchId(SaveSearchId: number): Observable<any> {

    return this.http.DeleteAsync(this.http.BaseUrl + "api/SaveSearches/SavedSearchesId?SavedSearchesId=" + SaveSearchId)
  }

  UpdateSaveSearchId(SaveSearchId: number, ObjSaveSearch: any): Observable<any> {

    return this.http.PutAsync<any>(this.http.BaseUrl + "api/SaveSearches/SavedSearchesId?SavedSearchesId=" + SaveSearchId, ObjSaveSearch);
  }

  IsSaveSearchExists(saveSearches: SaveSearches): Observable<boolean> {

    return this.http.PostAsync<boolean>(this.http.BaseUrl + "api/SaveSearches/IsSavedSearchExist", saveSearches);
  }

  CanUserSaveSearch(loggedInUserId: number, selectedDashboardTypeId: number): Observable<boolean> {

    return this.http.PostAsync<boolean>(this.http.BaseUrl + "api/SaveSearches/canUserSaveSearch?loggedInUserId=" + loggedInUserId + "&selectedDashboardTypeId=" + selectedDashboardTypeId, null);
  }

  UpdateIsActiveFlag(savedSearchId: number, isActive: boolean): Observable<boolean> {

    return this.http.PostAsync<boolean>(this.http.BaseUrl + "api/SaveSearches/UpdateIsActiveFlag?savedSearchId=" + savedSearchId + "&isActive=" + isActive, null);
  }

  GetUserSaveSearchesLimit(loggedInUserId: number, selectedDashBoardTypeId : number): Observable<any> {

    return this.http.GetAsync<number>(this.http.BaseUrl + "api/SaveSearches/GetUserSaveSearchesLimit?loggedInUserId=" + loggedInUserId + "&selectedDashBoardTypeId=" + selectedDashBoardTypeId);
  }

  GetUserTotalActiveSaveSearches(loggedInUserId: number): Observable<number> {

    return this.http.GetAsync<number>(this.http.BaseUrl + "api/SaveSearches/GetUserTotalActiveSaveSearches?loggedInUserId=" + loggedInUserId);
  }

  DeactivateOldestSaveSearch(loggedInUserId: number, selectedDashBoardTypeId : number): Observable<boolean> {

    return this.http.PostAsync<boolean>(this.http.BaseUrl + "api/SaveSearches/DeactivateOldestSaveSearch?loggedInUserId=" + loggedInUserId + "&selectedDashBoardTypeId=" + selectedDashBoardTypeId, null);
  }

  GetUserDefaultSavedSearch(userId: number, isRecruiter: boolean): Observable<SaveSearches> {

    return this.http.GetAsync<SaveSearches>(this.http.BaseUrl + "api/search/GetUserDefaultSavedSearch?userId=" + userId + "&isRecruiter=" + isRecruiter);
  }

  GetSavedSearchById(savedSearchId: number): Observable<SaveSearches> {
    return this.http.GetAsync<SaveSearches>(this.baseUrl + "api/SaveSearches/" + savedSearchId);
  }

  ValidateUserPackage(loggedInUserId: number): Observable<boolean> {

    return this.http.PutAsync(this.http.BaseUrl + "api/SaveSearches/ValidateUserPackage?userId=" + loggedInUserId, null);
  }

  
}